import { Injectable, Renderer2, Inject } from '@angular/core';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Injectable()
export class MediaCellOttService {
    renderer: Renderer2

    constructor( @Inject(APP_SETTINGS) protected settings: any) {
    }

    setupCellContent(component) {
        let cell = component.item.meta || component.item;
        cell.objType = this.getObjectType(cell);
        cell.isLiveStream = cell.objType == "stream";
        cell.cta = this.getCta(component, cell);
        cell.activeCta = this.getActiveCta(component, cell);
        cell.detail = this.getDetailInfo(cell);
        cell.runtime = cell.runtime || cell.video && (cell.video.meta || cell.video).runtime;
        if (cell.video && cell.video.meta) {
            if (cell.video.meta['snipe'] && !(cell['snipe'])) {
                cell.snipe = cell.video.meta['snipe'];
            }
        }
        if (!cell.snipe || cell.objType == "series") cell.snipe = {};
        
        if (cell.objType == "stream" && this.settings["ENABLE_PREVIEW_PLAYER"]) {
            component.configuration.playStream = true
        }

        if (!component.configuration.imageType) {
            switch (component.configuration.size) {
                case "tall":
                    component.configuration.imageType = this.settings["MEDIA_CEL_TALL_IMAGE"];
                    break;
                case "banner":
                    component.configuration.imageType = this.settings["MEDIA_CELL_BANNER_IMAGE"];
                    break;
                default:
                    component.configuration.imageType = this.settings["MEDIA_CELL_IMAGE"];
                    break;
            }
        }

        if (component.configuration.showLogo === undefined) {
            component.configuration.showLogo = this.settings["MEDIA_CELL_SERIES_LOGO"];
        }
        if (component.configuration.noLazy === undefined) {
            component.configuration.noLazy = !this.settings["MEDIA_CELL_LAZY_LOAD_IMAGES"];
        }
        
        component.configuration.noVideoMessage = this.settings["NO_VIDEO_MESSAGE"]

        component.content = cell;
    }

    getObjectType(meta: any): string {
        return (meta.obj_type || "").toLowerCase();
    }

    getActiveCta(component, meta: any): string {
        return component.selected && `${['video', 'episode', 'stream'].indexOf(meta.objType) > -1 ? "now playing" : ""}`;
    }

    getCta(component, meta: any): string {
        return !component.selected && `${['video', 'episode', 'stream'].indexOf(meta.objType) > -1 ? "play" : this.getObjectType(meta)}`;
    }

    getTags(meta: any): Array<any> {
        if (meta.primary_tag_endpoint != null) {
            return [meta.primary_tag_endpoint];
        }
        return null;
    }

    getDetailInfo(meta: any): any {
        return {
            title: meta.title,
            copy: meta.summary,
            subTitle: meta.counts_text || meta.sub_title || meta.job_title || this.getSubHead(meta),
            tags: this.getTags(meta),
            internal_route: meta.internal_route,
            //url: meta.url,
            target: meta.target,
            type: meta.objType,
            live: false
        };
    }

    getSubHead(meta: any) {
        return meta.obj_type == "Episode" ? `${meta.series && meta.series.title || ""} • ${meta.sub_head || ""}` : meta.sub_head;
    }

    /* Updates component meta from PubNub Message */
    updateSuperInfoFromMessage(component:any, message:any) {
        if (component && component.content) {
            const meta = (message && message["super"]) || message
            if (meta) {
                const detailCopy = JSON.parse(JSON.stringify(component.content.detail));
                detailCopy.title = meta.title;
                detailCopy.copy = meta.summary;
                detailCopy.subTitle = meta.sub_head;
                detailCopy.live = meta.live;
                component.content.detail = detailCopy;
                component.ref.detectChanges();
            }
        }
    }

    updateNotificationFromMessage(component:any, message:any) {
        if (component && component.content) {
            const meta = (message && message["notification"]) || message
            if (meta) {
                const detailCopy = JSON.parse(JSON.stringify(component.content.detail));
                detailCopy.title = meta.message;
                component.content.importance = meta.importance;
                component.content.detail = detailCopy;     
                component.content.item = { internal_route: meta.alertUrl };
                component.ref.detectChanges();
            }
            else {
                component.content.item = null;
                component.ref.detectChanges();
            }
        }
    }

    pubNubSubscriptionRequired(component): boolean {
        return component.content && 
            ((component.content.isLiveStream && component.content.live_super && component.settings.LIVE_SUPER_AUTOREFRESH) ||
            (component.content.objType == "notification" && component.settings.NOTIFICATION_MESSAGES))
    }
 }


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/components/media-cell.ott.service.ts